import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDocRelatedRecords } from "../../../api/transaction-type";
import {
  salesOrderTransactionsTable,
  invoicePaymentsTable,
  invoiceSupportCasesTable,
  salesOrderRelatedRecordTable,
  salesOrderRelatedRecordTransformationTable,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function SalesOrderRelatedRecords({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);
  // useEffect(() => {
  //   if (user.token && tabIndexP === 6) {
  //     getTransactionRelatedRecordsData();
  //   }
  // }, [tabIndexP]);
  async function getTransactionRelatedRecordsData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionDocRelatedRecords(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data.data);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {params.slug === "sales-order" ? (
        <Box p={1}>
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="Transformation" />
            <Tab label="Related Records" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            <AgGridPaginatedTable
              getTableRows={getTransactionNotAvailable}
              columns={salesOrderRelatedRecordTransformationTable}
              refreshCounter={0}
            />
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <AgGridPaginatedTable
              getTableRows={getTransactionRelatedRecordsData}
              // getTableRows={getTransactionRelatedRecordsData}
              columns={salesOrderRelatedRecordTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
        </Box>
      ) : params.slug === "return-authorization" ? (
        <Box
          className="viewBox sub-tab"
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg1"
          >
            <Tab label="Transactions" />
            <Tab label="Receipts & Refunds" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            {/*Transactions*/}
            <Box className="viewDetilsBox">
              <Grid container className="mb-2" spacing={2}>
                <Grid item xs={12} sm={4} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      TRANSACTION
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="TRANSACTION"
                    >
                      <MenuItem value="list">List</MenuItem>
                      <MenuItem value="list">Search</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            <AgGridPaginatedTable
              //getTableRows={tabIndexP===7 || tabIndexR===6 || tabIndexB===8 ? getTransactionRelatedRecordsData : []}
              getTableRows={getTransactionRelatedRecordsData}
              columns={salesOrderTransactionsTable}
              perPage={5}
              refreshCounter={0}
            />
            {/*Transactions*/}
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            Receipts & Refunds
          </TabPanel>
        </Box>
      ) : params.slug === "bill-payment" ? (
        <Box
          className="viewBox sub-tab"
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg1"
          >
            <Tab label="Transactions" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            {/*Transactions*/}
            <Box className="viewDetilsBox">
              <Grid container className="mb-2" spacing={2}>
                <Grid item xs={12} sm={4} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="list">Default</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      TRANSACTION
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="TRANSACTION"
                    >
                      <MenuItem value="list">List</MenuItem>
                      <MenuItem value="list">Search</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            <AgGridPaginatedTable
              //getTableRows={tabIndexP===7 || tabIndexR===6 || tabIndexB===8 ? getTransactionRelatedRecordsData : []}
              getTableRows={getTransactionRelatedRecordsData}
              columns={salesOrderTransactionsTable}
              perPage={5}
              refreshCounter={0}
            />
            {/*Transactions*/}
          </TabPanel>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
